/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/patchFeatureFlagOverrides';
import type { PatchFeatureFlagRequestBody } from '../../operation-overrides/patchFeatureFlagOverrides';

export type PatchFeatureFlagPathParams = NonNullable<operations['patchFeatureFlag']['parameters']['path']>;

export type PatchFeatureFlagQueryParams = NonNullable<operations['patchFeatureFlag']['parameters']['query']>;
export type { PatchFeatureFlagRequestBody };

export interface Input extends PatchFeatureFlagPathParams {
  apiVersion?: string;
  query?: PatchFeatureFlagQueryParams;
  body: PatchFeatureFlagRequestBody;
}

export async function patchFeatureFlag(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/flags/{projectKey}/{featureFlagKey}', {
    params: { path, query },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    body,
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    bodySerializer: overrides.bodySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
